<div
    class="tw-bg-[#0A0A75] tw-text-white tw-flex tw-items-start md:tw-items-center tw-px-[25px] md:tw-px-[30px] tw-gap-10 tw-relative tw-pt-8 md:tw-py-4 tw-pb-0 tw-h-[388px] md:tw-h-[285px] xl:tw-h-[365px]"
>
    <div
        class="tw-max-w-[1280px] tw-flex tw-items-center tw-gap-[50px] md:tw-gap-0 tw-flex-col md:tw-flex-row tw-w-full tw-mx-auto"
    >
        <!-- Left Content -->
        <div
            class="tw-text-center tw-max-w-[320px] tw-mx-auto sm:tw-mx-0 sm:tw-text-left tw-relative tw-z-10 lg:tw-max-w-[500px]"
        >
            <p
                class="tw-w-full tw-text-[26px] md:tw-text-[38px] tw-text-white tw-font-bold tw-leading-[100%] lg:tw-leading-[47px]"
            >
                {{ "DIGITAL_SERVICES.BUKKU.MAIN_TITLE" | translate }}
            </p>
            <p
                class="!tw-text-[13px] md:!tw-text-[14px] tw-mb-6 tw-font-normal tw-leading-[141%] lg:tw-leading-[22px]"
            >
                {{ "DIGITAL_SERVICES.BUKKU.MAIN_DESC" | translate }}
            </p>
        </div>

        <!-- Right Content -->
        <div
            class="tw-w-full tw-flex tw-flex-col md:tw-h-full tw-items-center md:tw-justify-end tw-relative"
        >
            <div class="tw-relative tw-w-fit md:tw-ml-auto">
                <img
                    src="/assets/images/bukku/landscape.png"
                    alt="Bukku services"
                    class="tw-w-fit tw-h-auto md:tw-self-end md:tw-h-full md:tw-object-contain md:tw-object-bottom tw-max-w-[225px] md:tw-max-w-[300px] xl:tw-max-w-[437px] tw-relative tw-z-[2]"
                />
                <img
                    src="/assets/images/bukku/vector.svg"
                    alt="Bukku services"
                    class="tw-absolute md:tw-w-[100px] xl:tw-w-auto tw-left-[-50px] tw-top-[-20px] md:tw-block tw-hidden"
                />
            </div>
        </div>
    </div>
</div>
